import type { ConnectionOptions } from "bullmq";
import { env } from "./env.js";

const redisUrl = new URL(env.REDIS_URL);

export const bullmqConnectionConfig: ConnectionOptions = {
  host: redisUrl.hostname,
  port: redisUrl.port ? parseInt(redisUrl.port, 10) : 6379,
  username: redisUrl.username || undefined,
  password: redisUrl.password || undefined,
  db: redisUrl.pathname ? parseInt(redisUrl.pathname.substring(1), 10) || 0 : 0,
  tls: redisUrl.protocol === "rediss:" ? {} : undefined,
  maxRetriesPerRequest: null,
};
